import styled from 'styled-components';
import { TabMixin } from '../../mixins/components/TabMixin';
import { ToggleButton } from '../ToggleButton/ToggleButton';
export var StyledTab = /*#__PURE__*/styled(ToggleButton).withConfig({
  displayName: "StyledTab",
  componentId: "c11n-8-107-0__sc-xahs5k-0"
})(["", ""], TabMixin);